/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterOriginAidRequest
 */
export interface FilterOriginAidRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterOriginAidRequest
     */
    aids?: Array<string>;
    /**
     * User's email.
     * @type {string}
     * @memberof FilterOriginAidRequest
     */
    email: string;
}

/**
 * Check if a given object implements the FilterOriginAidRequest interface.
 */
export function instanceOfFilterOriginAidRequest(value: object): boolean {
    if (!('email' in value)) return false;
    return true;
}

export function FilterOriginAidRequestFromJSON(json: any): FilterOriginAidRequest {
    return FilterOriginAidRequestFromJSONTyped(json, false);
}

export function FilterOriginAidRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterOriginAidRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'aids': json['aids'] == null ? undefined : json['aids'],
        'email': json['email'],
    };
}

export function FilterOriginAidRequestToJSON(value?: FilterOriginAidRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aids': value['aids'],
        'email': value['email'],
    };
}

